import { CurrencyPipe, DatePipe, DecimalPipe, TitleCasePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { PreloadAllModules, RouteReuseStrategy, provideRouter, withPreloading } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';
import { AgentTypeEffect } from 'projects/shared/src/lib/@ngrx/agent-type/agent-type.effect';
import { AuthEffect } from 'projects/shared/src/lib/@ngrx/auth/auth.effect';
import { CodeEffect } from 'projects/shared/src/lib/@ngrx/code/code.effect';
import { CompanyEffect } from 'projects/shared/src/lib/@ngrx/company/company.effect';
import { ConfigurationEffect } from 'projects/shared/src/lib/@ngrx/configuration/configuration.effect';
import { CourseEffect } from 'projects/shared/src/lib/@ngrx/course/course.effect';
import { metaReducers, reducers } from 'projects/shared/src/lib/@ngrx/index.reducer';
import { MenuEffect } from 'projects/shared/src/lib/@ngrx/menu/menu.effect';
import { UserEffect } from 'projects/shared/src/lib/@ngrx/user/user.effect';
import { UserGroupEffect } from 'projects/shared/src/lib/@ngrx/user-group/user-group.effect';
import { ESystem } from 'projects/shared/src/lib/models/index.model';
import { AuthenticationInterceptorService } from 'projects/shared/src/lib/services/Interceptors/authentication-interceptor.service';
import { environment } from 'projects/shared/src/environments/environment';

import { routes } from './app.routes';
import { NativeHttpInterceptor } from './core/native-http.interceptor';

function setMobileVariables() {
  environment.appName = 'Portal Companion';
  environment.system = ESystem.admin;
  environment.sentryKey =
    'https://92c694630cb97e9aa95d2fd63bf4e3da@o4507594374250496.ingest.de.sentry.io/4507596104597584';

  if (!Capacitor.isNativePlatform() && isLocalMobileHost()) {
    environment.apiBaseUrl = '/api/core/';
    environment.apiWorkflowBaseUrl = '/api/workflow/';
    environment.apiGatewayBaseUrl = '/api/gateway/';
    environment.apiMessagingBaseUrl = '/api/messaging/';
    environment.apiPolicyBaseUrl = '/api/policy/';
    environment.apiUserServiceBaseUrl = '/api/user/';
  }
}

function isLocalMobileHost() {
  if (typeof location === 'undefined') return false;

  const host = location.hostname;
  return (
    host === 'localhost' ||
    host === '0.0.0.0' ||
    host === '::1' ||
    host.endsWith('.local') ||
    host.startsWith('127.') ||
    host.startsWith('10.') ||
    host.startsWith('192.168.') ||
    /^172\.(1[6-9]|2\d|3[0-1])\./.test(host)
  );
}

setMobileVariables();

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideIonicAngular(),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideStore(reducers, { metaReducers }),
    provideEffects(
      AgentTypeEffect,
      AuthEffect,
      CodeEffect,
      CompanyEffect,
      ConfigurationEffect,
      CourseEffect,
      MenuEffect,
      UserEffect,
      UserGroupEffect,
    ),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NativeHttpInterceptor,
      multi: true,
    },
    CurrencyPipe,
    DatePipe,
    DecimalPipe,
    TitleCasePipe,
  ],
};
